import { Text } from '@chakra-ui/react'
import React from 'react'

import { ConfirmDialog } from '@mangovoice/mango-ui'

import type { SwitchboardTranslateFn } from '../../types'
import { text } from '../../utils/text'

export interface DeleteNodeConfirmationDialogProps {
  isOpen: boolean
  nodeLabel?: string
  onConfirm: () => void
  onCancel: () => void
  t?: SwitchboardTranslateFn
}

/**
 * Confirmation dialog for deleting a node
 */
export const DeleteNodeConfirmationDialog: React.FC<
  DeleteNodeConfirmationDialogProps
> = ({ isOpen, nodeLabel, onConfirm, onCancel, t }) => {
  const bodyText = nodeLabel
    ? text(
        t,
        'switchboard.dialogs.deleteNode.bodyWithLabel',
        'Are you sure you want to delete "{{label}}"?',
        { label: nodeLabel },
      )
    : text(
        t,
        'switchboard.dialogs.deleteNode.body',
        'Are you sure you want to delete this node?',
      )

  const warningText = text(
    t,
    'switchboard.dialogs.deleteNode.warning',
    'This action cannot be undone. All connections to this node will also be removed.',
  )

  return (
    <ConfirmDialog
      open={isOpen}
      onClose={onCancel}
      title={text(t, 'switchboard.dialogs.deleteNode.title', 'Delete Node')}
      description={bodyText}
      confirmLabel={text(t, 'switchboard.dialogs.deleteNode.confirm', 'Delete')}
      cancelLabel={text(t, 'switchboard.dialogs.deleteNode.cancel', 'Cancel')}
      onConfirm={onConfirm}
      variant="destructive"
    >
      <Text fontSize="sm" color="fg.muted" lineHeight="1.5" mt={2}>
        {warningText}
      </Text>
    </ConfirmDialog>
  )
}
